import React, { useState } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
} from '@material-ui/core'
import { updateProductionAndLossed } from '../../../../../services/Elegibilidad/put'
import swal from 'sweetalert'
import NumberFormat from 'react-number-format'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ReactTooltip from 'react-tooltip'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

export const Modal35Edit = ({
  open,
  setOpen,
  body,
  setBody,
  getDataTableProductionAndLoss,
}) => {
  const [errorAntecedentes, setErrorAntecedentes] = useState(false)
  const [errorUnidad1, setErrorUnidad1] = useState(false)
  const [errorUnidad2, setErrorUnidad2] = useState(false)
  const [loading, setLoading] = useState(false)

  const {
    IdProductionAndLosseByClimate,
    IdElegibilityAnswer,
    Area,
    IdCategory,
    CategoryDesc,
    Hectares,
    SubProjectHectares,
    RecentClimaticEvent,
    AnnualAverageYieldUnit,
    AnnualAverageYield,
    AnnualEstimatedLossUnit,
    AnnualEstimatedLoss,
  } = body

  const GeneralDataSchema = Yup.object().shape({
    RecentClimaticEvent: Yup.string()
      .required('Este Campo es obligatorio')
      .matches(
        /^[-(),./\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(400, 'Máximo 400 caracteres'),
    AnnualAverageYieldUnit: Yup.string()
      .required('Este Campo es obligatorio')
      .matches(
        /^[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(40, 'Máximo 40 caracteres'),
    AnnualAverageYield: Yup.number().required('Este campo es obligatorio'),
    AnnualEstimatedLossUnit: Yup.string()
      .required('Este Campo es obligatorio')
      .matches(
        /^[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(40, 'Máximo 40 caracteres'),
    AnnualEstimatedLoss: Yup.number().required('Este campo es obligatorio'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdProductionAndLosseByClimate: IdProductionAndLosseByClimate,
      IdElegibilityAnswer: IdElegibilityAnswer,
      Area: Area,
      IdCategory: IdCategory,
      CategoryDesc: CategoryDesc,
      Hectares: Hectares,
      SubProjectHectares: SubProjectHectares,
      RecentClimaticEvent: RecentClimaticEvent,
      AnnualAverageYieldUnit: AnnualAverageYieldUnit,
      AnnualAverageYield: AnnualAverageYield,
      AnnualEstimatedLossUnit: AnnualEstimatedLossUnit,
      AnnualEstimatedLoss: AnnualEstimatedLoss,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: () => {
      handleGuardar(formik.values)
    },
  })

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
    setErrorAntecedentes(false)
    setErrorUnidad1(false)
    setErrorUnidad2(false)
    setLoading(false)
  }

  const handleGuardar = async (values) => {
    setLoading(true)
    const response = await updateProductionAndLossed(values)
    if (response.Success) {
      swal({
        title: '¡Datos actualizados exitosamente!',
        icon: 'success',
      })
      getDataTableProductionAndLoss()
      handleClose()
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">
              Pérdida de producción debido a eventos relacionados con el clima{' '}
            </h1>
          </div>
          <form id="transfers-form" onSubmit={formik.handleSubmit}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Puede llenar uno o más campos, según su caso.
              </label>
            </Grid>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Rubro / Producto</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Rubro / Producto"
                    customInput={TextField}
                    value={formik.values.Area}
                    disabled
                  ></textarea>
                </FormControl>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
                className="input__container"
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Categoría</label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <TextField
                        id="MiPymeCountry"
                        name="MiPymeCountry"
                        type="text"
                        variant="outlined"
                        sx={{ width: 220 }}
                        value={formik.values.CategoryDesc}
                        disabled
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Área de producción
                    </label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <NumberFormat
                        id="cantHectareasSubproyecto"
                        name="cantHectareasSubproyecto"
                        customInput={TextField}
                        allowLeadingZeros={false}
                        thousandSeparator={true}
                        value={formik.values.SubProjectHectares}
                        autoComplete="off"
                        variant="outlined"
                        allowNegative={false}
                        disabled
                        isNumericString={true}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Antecedentes evento cambio climático más reciente
                </label>
                <a
                  data-tip="Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, coma y punto."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Antecedentes"
                    customInput={TextField}
                    value={formik.values.RecentClimaticEvent}
                    onChange={(e) => {
                      if (
                        e.target.value.match(
                          /[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                        ) ||
                        e.target.value === ''
                      ) {
                        setErrorAntecedentes(false)
                        formik.setFieldValue(
                          'RecentClimaticEvent',
                          e.target.value,
                        )
                      } else {
                        setErrorAntecedentes(true)
                      }
                    }}
                    maxLength={40}
                  ></textarea>
                  {errorAntecedentes ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.RecentClimaticEvent ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.RecentClimaticEvent}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'stretch',
                }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textDecoration: 'underline ', marginTop: '5px' }}
                >
                  <label className="responsiveLabel">
                    Rendimiento promedio anual (años anteriores)
                  </label>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Unidad</label>
                      <a
                        data-tip="Se refiere a la unidad de medida de la producción (Quintales, toneladas, etc.) <br/>  Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, coma y punto."
                        data-for="infoCurrencyPop"
                        style={{ cursor: 'pointer' }}
                      >
                        <ErrorOutlineIcon fontSize="small" />
                        <ReactTooltip
                          id="infoCurrencyPop"
                          effect="solid"
                          multiline={true}
                          type="dark"
                        />
                      </a>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <TextField
                          id="MiPymeCountry"
                          name="MiPymeCountry"
                          type="text"
                          variant="outlined"
                          sx={{ width: 220 }}
                          inputProps={{
                            maxLength: 40,
                          }}
                          value={formik.values.AnnualAverageYieldUnit}
                          onChange={(e) => {
                            if (
                              e.target.value.match(
                                /[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                              ) ||
                              e.target.value === ''
                            ) {
                              setErrorUnidad1(false)
                              formik.setFieldValue(
                                'AnnualAverageYieldUnit',
                                e.target.value,
                              )
                            } else {
                              setErrorUnidad1(true)
                            }
                          }}
                          error={formik.errors.AnnualAverageYieldUnit}
                        />
                        {errorUnidad1 ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            Caracteres especiales no aceptados
                          </div>
                        ) : null}
                        {formik.errors.AnnualAverageYieldUnit ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.AnnualAverageYieldUnit}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Cantidad</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="cantHectareasSubproyecto"
                          name="cantHectareasSubproyecto"
                          customInput={TextField}
                          thousandSeparator={true}
                          value={formik.values.AnnualAverageYield}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          allowLeadingZeros={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'AnnualAverageYield',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          isNumericString={true}
                          inputProps={{ maxLength: 10 }}
                          decimalScale={2}
                          error={formik.errors.AnnualAverageYield}
                          fixedDecimalScale
                        />
                      </FormControl>
                      {formik.errors.AnnualAverageYield ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.AnnualAverageYield}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'stretch',
                }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textDecoration: 'underline ', marginTop: '5px' }}
                >
                  <label className="responsiveLabel">
                    Pérdida estimada anual relacionada con el clima (años
                    anteriores)
                  </label>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Unidad</label>
                      <a
                        data-tip="Se refiere a la unidad de medida de la producción (Quintales, toneladas, etc.) <br/>  Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, coma y punto."
                        data-for="infoCurrencyPop"
                        style={{ cursor: 'pointer' }}
                      >
                        <ErrorOutlineIcon fontSize="small" />
                        <ReactTooltip
                          id="infoCurrencyPop"
                          effect="solid"
                          multiline={true}
                          type="dark"
                        />
                      </a>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <TextField
                          id="MiPymeCountry"
                          name="MiPymeCountry"
                          type="text"
                          variant="outlined"
                          sx={{ width: 220 }}
                          value={formik.values.AnnualEstimatedLossUnit}
                          onChange={(e) => {
                            if (
                              e.target.value.match(
                                /[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                              ) ||
                              e.target.value === ''
                            ) {
                              setErrorUnidad2(false)
                              formik.setFieldValue(
                                'AnnualEstimatedLossUnit',
                                e.target.value,
                              )
                            } else {
                              setErrorUnidad2(true)
                            }
                          }}
                          inputProps={{
                            maxLength: 40,
                          }}
                          error={formik.errors.AnnualEstimatedLossUnit}
                        />
                        {errorUnidad2 ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            Caracteres especiales no aceptados
                          </div>
                        ) : null}
                        {formik.errors.AnnualEstimatedLossUnit ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.AnnualEstimatedLossUnit}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Cantidad</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="cantHectareasSubproyecto"
                          name="cantHectareasSubproyecto"
                          allowLeadingZeros={false}
                          customInput={TextField}
                          thousandSeparator={true}
                          value={formik.values.AnnualEstimatedLoss}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'AnnualEstimatedLoss',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          isNumericString={true}
                          inputProps={{ maxLength: 10 }}
                          decimalScale={2}
                          fixedDecimalScale
                          error={formik.errors.AnnualEstimatedLoss}
                        />
                        {formik.errors.AnnualEstimatedLoss ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.AnnualEstimatedLoss}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  onClick={validateFormStatus}
                  disabled={loading}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  )
}
